/**
 * Serve Supabase Storage assets through our own VPS proxy (/api/img, disk-
 * cached, immutable browser caching) instead of hitting Supabase directly —
 * direct URLs burned through the free-tier cached-egress quota (12.96 GB vs
 * 5 GB in Aug 2026, services threatened with 402s). Non-storage URLs pass
 * through untouched, so this is safe to wrap around any image src.
 */
export function cdn(u: string | null | undefined): string {
  if (!u) return ''
  const marker = '/storage/v1/object/public/'
  const i = u.indexOf(marker)
  return i < 0 ? u : '/api/img?p=' + encodeURIComponent(u.slice(i + marker.length))
}
